import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  outMembers: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "outMember",
  initialState,
  reducers: {
    getOutMemberSuccess: (state, { payload }) => {
      state.outMembers = payload;
      state.loading = false;
    },
    startLoadingOutMember: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getAllOutMembers = ({ accessToken, page }) => {

  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
     
      dispatch(slice.actions.startLoadingOutMember());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-outMembers`,
        { headers }
      );
      dispatch(slice.actions.getOutMemberSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};

